import baseURL from "../common/axios";
class Genralservices {
  // Calling dropdown value for country, state, city

  RequestCategoryList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/RequestCategoryList");
  }
  countrydd(data) {
    debugger;
    return baseURL.httpbaseURL.post("DoctorCreation/GetCountry", data);
  }
  loadLocationList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/LoadLocationList");
  }

  //LoadCountry
  LoadCountry() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/LoadCountry");
  }
  //Load State
  LoadState(CountryId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/GetByCountryId?CountryId=" + CountryId + ""
    );
  }
  //Load City
  LoadCity(StateId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/GetByStateId?StateId=" + StateId + ""
    );
  }
  //To Get Code based on Form Id
  getCodeTemplate(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/GetCode?EntityId=" +
      data.EntityId +
      "&HospitalId=" +
      data.HospitalId +
      "&BranchId=" +
      data.BranchId +
      "&StoreId=" +
      data.StoreId +
      "&IsCommon=" +
      (data.Iscommon ? data.Iscommon : 0) +
      "&RoleId=" +
      (data.RoleId ? data.RoleId : 0) +
      ""
    );
  }

  CodeTemplateList(BranchId, OrganizationId, Type, StoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/GetCodeTemplateList?BranchId=" +
      BranchId +
      "&OrganizationId=" +
      OrganizationId +
      "&Type=" +
      Type +
      "&StoreId=" +
      StoreId +
      ""
    );
  }

  CreateCodeTemplate(CodeTemplateList) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "Common/CreateCodeTemplate",
      CodeTemplateList
    );
  }

  // file upload api call
  // fileupload(formdata) {
  //   debugger;
  //   return baseURL.httpbaseURL.post("ByteArrayAPI/InventoryImages", formdata, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // }
  fileupload(formdata, FolderName) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "FileUpload/InventoryImages?FolderName=" + FolderName,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  // ExcelFileUpload api call
  ExcelFileUpload(formdata) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("Common/ExcelFileUpload", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  //To Get Code based on Form Id
  TaxDiscalulation(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "CalculationLogic/TaxDiscalulation",
      data
    );
  }

  //To Load Patient
  getPatient(HospitalCode, BranchId, PatientName, VisitType, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "Common/LoadPatient?HospitalCode=" +
      HospitalCode +
      "&BranchId=" +
      BranchId +
      "&PatientName=" +
      PatientName +
      "&VisitType=" +
      VisitType +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }

  //To Load User-->HMS API
  getUser(HospitalId, BranchId, UserName) {
    return baseURL.httpMSInventoryUrl.get(
      "Common/LoadUser?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&UserName=" +
      UserName +
      ""
    );
  }
  departmentList(hospitalCode, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/DepartmentListHMS?hospitalCode=" +
      hospitalCode +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }
  subDepartmentList(departmentId, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/SubDepartmentListHMS?departmentId=" +
      departmentId +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }
  categoryListHMS(hospitalCode, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/CategoryListHMS?hospitalCode=" +
      hospitalCode +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }
  subCategoryListHMS(categoryId, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Common/SubCategoryListHMS?categoryId=" +
      categoryId +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }

  LoadOrganizationList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/OrganizationList");
  }

  LoadBranchList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/BranchList");
  }

  LoadDepartmentList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/DepartmentList");
  }

  LoadSubDepartmentList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/SubDepartmentList");
  }
  LoadOrganizationConfigList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/OrganizationConfigList");
  }
  uploadquotation(formdata, FolderName) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "FileUpload/UploadFile?FolderName=" + FolderName,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  CreateProductImageMAS(dataModel) {
    return baseURL.httpMSInventoryUrl.post(
      "ProductImagesMAS/Create",
      dataModel
    );
  }
  DeleteList(Id) {
    return baseURL.httpMSInventoryUrl.delete("ProductImagesMAS/DeleteList?id=" + Id)
  }
  GetProductImageByItemId(Id) {
    return baseURL.httpMSInventoryUrl.get("ProductImagesMAS/Get?ItemId=" + Id);
  }

  GetLastTransactionDetails(HospitalId, BranchId, DocType, StoreId, ItemId) {
    return baseURL.httpMSInventoryUrl.get(
      "Common/GetLastTransactionDetails?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&DocType=" +
      DocType +
      "&StoreId=" +
      StoreId +
      "&ItemId=" +
      ItemId
    );
  }


  ScheduleList() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/ScheduleList");
  }

  GetModulesByOrganizationId(OrganizationId) {
    return baseURL.httpMSInventoryUrl.get("Common/GetModulesByOrganizationId?OrganizationId=" + OrganizationId);
  }

}
export default new Genralservices();
